import { Form, Flex, Typography } from "antd";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { createContract } from "services";
import { routes } from "constants/routes";
import { components } from "types/openapi";
import { parseErrorMessage, removeSpaces, dateISOFormat } from "utils";
import { ContractForm } from "components";
import { CreateContractRequest, NOTIFICATION_TYPE_ENUM } from "interfaces";
import { useNotificationContext } from "providers";
import { ReturnButton } from "ui";

type FieldType = components["schemas"]["CreateContractRequest"] & {
  counterpartyLegalAddress?: string;
  counterpartyActualAddress?: string;
};

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export const ContractCreatePage = () => {
  const navigate = useNavigate();
  const { openNotification } = useNotificationContext();
  const query = useQuery();
  const companyId = query.get("companyId");

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const cancelCreateContract = () => {
    return Promise.resolve(navigate(`/${routes.contracts}`));
  };

  const closeResultModal = (id: string) => {
    return Promise.resolve(navigate(`/${routes.contracts}/${id}`));
  };

  const saveContract = async () => {
    setLoading(true);
    const values: FieldType = form.getFieldsValue();

    const formData: CreateContractRequest = {
      ...values,
      date: dateISOFormat(values.date),
      fiatAmount: values.fiatAmount,
      docs: form.getFieldValue("docs"),
      unk: removeSpaces(values.unk),
      companyId: companyId ?? undefined,
    };

    await createContract(formData)
      .then((id) => {
        openNotification({
          message: "Договор успешно создан",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
        setTimeout(() => {
          setLoading(false);
          closeResultModal(id);
        }, 1500);
      })
      .catch((e) => {
        setLoading(false);
        openNotification({
          description: parseErrorMessage(e),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      });
  };
  return (
    <Flex vertical>
      <Flex align="center" gap="8px">
        <ReturnButton onClick={cancelCreateContract} disabled={loading} loading={loading} className="bg-basic-300" />
        <Typography.Title>Добавление нового договора</Typography.Title>
      </Flex>
      <ContractForm form={form} disabled={loading} onFinish={saveContract} />
    </Flex>
  );
};
